import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToolEnum } from 'src/Models/Common';
import { FilterModel } from 'src/Models/filterModel';
import { WebinarLibraryModel } from 'src/Models/WebinarLibraryModel';
import { CheckAuth } from 'src/Services/utility.service';
import { WebinarLibraryService } from 'src/Services/webinar-library.service';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-webinar-library',
  templateUrl: './webinar-library.component.html',
  styleUrls: ['./webinar-library.component.css']
})
export class WebinarLibraryComponent implements OnInit {
  filterModel = new FilterModel();
  currentPage: number = 1;
  totalRecordCount: number = -1;

  listOfWebinarLibraries: WebinarLibraryModel[];
  listOfWebinarLibrariesExport: WebinarLibraryModel[];

  isUserSystemAdmin: boolean = true;
  tokenKey: string = '';
  SelectedTool: string;

  isAscending: boolean = false
  upDowTitleCSS: string = '';
  upDowURLCSS: string = '';
  upDowIsActiveCSS: string = '';
  upDowIsIsAllowallAccessCSS: string = '';
  upDowCreatedDateCSS: string = '';
  upDowModifiedDateCSS: string = '';
  upDowSortOrderCSS: string = '';
  upDowSectionCSS: string = '';

  productId: number = 1;
  deletedId: number = 0;
  isloading: boolean;
  selectedItemsStatus = [];
  selectedItemsFree = [];
  dropdownSettingsStatus = {};
  dropdownSettingsFree = {};
  listOfStatus = [];
  statusId: string = ' ';
  listOfFree = [];
  freeId: string = ' ';
  moduleList: any[] = [{ itemName: 'Yes', id: '1' }, { itemName: 'No', id: '0' }];
  dropdownListSection = [];
  dropdownSettingsSections = {};
  selectedItemsSections = [];
  listOfSectionID: string[] = [];
  selectedItemsSection = [];
  listOfSection?: string;
  PageNumber: number;
  specialReportId: number = 0;
  openMenuIndex: number = -1;

  constructor(private readonly activedRoute: ActivatedRoute,
    private readonly webinarService: WebinarLibraryService,
    private readonly router: Router,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.productId = ToolEnum[this.SelectedTool];
    this.titleService.setTitle('Webinar Library');
    this.filterModel.pageNumber = '1';
    this.filterModel.pageSize = '10';
    this.filterModel.orderBy = 'SortOrder';
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.dropdownSettingsSections = {
      singleSelection: true,
      text: "Filter by Sections",
      enableSearchFilter: true,
      classes: 'borderLessTextBoxGreen',
      noDataLabel: 'No Section available',
    };
    this.dropdownSettingsStatus = {
      singleSelection: true,
      text: "Filter by Active",
      enableSearchFilter: false,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No record available',
      showCheckbox: false
    };
    this.dropdownSettingsFree = {
      singleSelection: true,
      text: "Filter by Free",
      enableSearchFilter: false,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No record available',
      showCheckbox: false
    };

    this.activedRoute.params.subscribe((params: Params) => {
      if (params['id']) {
        if (params['id'] != null) {

          this.specialReportId = params['id'];
          this.GetWebinarLibrariesData();
        }
      }
    });
    this.GetWebinarLibrariesData();
    this.getAllSections();

  }

  GetWebinarLibrariesData() {
    this.isloading = true;
    this.filterModel.IsExport = false;
    this.listOfWebinarLibraries = [];
    this.webinarService.i360WebinarLibraryGet(this.tokenKey, this.filterModel).subscribe(
      data => {
        this.isloading = false;
        if (data != null) {
          this.listOfWebinarLibraries = data['webinarLibraryData'];
          if (this.listOfWebinarLibraries != null) {
            if (this.listOfWebinarLibraries.length > 0) {
              this.totalRecordCount = this.listOfWebinarLibraries[0].totalRecordCount;
            }
            else {
              this.totalRecordCount = 0;
            }
          }
          else {
            this.totalRecordCount = 0;
          }
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  keywordFilters($event) {
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    if ($event.target.value != "" && $event.target.value != null) {
      this.filterModel.whereCondition = $event.target.value;
    }
    else {
      this.filterModel.whereCondition = '';
    }
    this.GetWebinarLibrariesData();
  }

  pageChanged($event: any) {
    this.currentPage = $event.page;
    this.filterModel.pageNumber = parseInt($event.page).toString();
    this.GetWebinarLibrariesData();
  }

  cleanCssClass() {
    this.upDowTitleCSS = '';
    this.upDowIsActiveCSS = '';
    this.upDowIsIsAllowallAccessCSS = '';
    this.upDowCreatedDateCSS = '';
    this.upDowModifiedDateCSS = '';
    this.upDowSectionCSS = '';
    this.upDowSortOrderCSS = '';
  }

  // sort(sortBy: any) {
  //   this.cleanCssClass();
  //   this.isAscending = !this.isAscending;
  //   this.filterModel.orderBy = this.isAscending ? sortBy : sortBy + ' DESC';
  //   this.filterModel.pageNumber = '1';
  //   this.currentPage = 1;

  //   switch (sortBy) {
  //     case "title": this.upDowTitleCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case "isActive": this.upDowIsActiveCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case "isAllowallAccess": this.upDowIsIsAllowallAccessCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case "CreatedDate": this.upDowCreatedDateCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case "ModifiedDate": this.upDowModifiedDateCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case "sortOrder": this.upDowSortOrderCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case "sectionName": this.upDowSectionCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;

  //     default: break;
  //   }
  //   this.GetWebinarLibrariesData();
  // }


  sort(sortBy: any) {
    this.upDowTitleCSS = '';
    this.upDowIsActiveCSS = '';
    this.upDowIsIsAllowallAccessCSS = '';
    this.upDowCreatedDateCSS = '';
    this.upDowModifiedDateCSS = '';
    this.upDowSortOrderCSS = '';
    this.upDowSectionCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.filterModel.orderBy = sortBy + ' DESC';

      if (sortBy === "title") {
        this.upDowTitleCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "isActive") {
        this.upDowIsActiveCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "isAllowallAccess") {
        this.upDowIsIsAllowallAccessCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "CreatedDate") {
        this.upDowCreatedDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "ModifiedDate") {
        this.upDowModifiedDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "sortOrder") {
        this.upDowSortOrderCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "sectionName") {
        this.upDowSectionCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.filterModel.orderBy = sortBy;

      if (sortBy === "title") {
        this.upDowTitleCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "isActive") {
        this.upDowIsActiveCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "isAllowallAccess") {
        this.upDowIsIsAllowallAccessCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "CreatedDate") {
        this.upDowCreatedDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "ModifiedDate") {
        this.upDowModifiedDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "sortOrder") {
        this.upDowSortOrderCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "sectionName") {
        this.upDowSectionCSS = 'fa fa-arrow-up';
      }
    }

    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetWebinarLibrariesData();
  }

  addWebinarLibrary() {
    this.router.navigate(['admin/jsi360/WebinarLibrary/manage']);
  }

  editData(id) {
    this.router.navigate(['admin/jsi360/WebinarLibrary/manage/' + id])
  }

  setDeleteData(ids) {
    this.deletedId = ids;
  }

  deleteRecord(deletedId) {
    this.webinarService.i360WebinarLibraryDelete(this.tokenKey, deletedId).subscribe(
      data => {
        this.deletedId = 0;
        if (data != null) {
          if (data['deletedId'] > 0) {
            this.GetWebinarLibrariesData();
            this.toastr.success('Record deleted successfully.', 'Delete')
          }
        }
      },
      error => {
      }
    );
  }

  onSelectStatus($event) {
    this.listOfStatus = this.removeElemetninArray(this.listOfStatus, $event.id)
    this.listOfStatus.push($event.id);
    this.statusId = ' ';
    if (this.listOfStatus.length > 0) {
      this.statusId = $event.id;
      this.filterModel.statusId = this.statusId;
    } else {
      this.filterModel.statusId = null;
    }
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetWebinarLibrariesData();
  }

  onDeSelectStatus($event) {
    if (this.listOfStatus != null) {
      if (this.listOfStatus.length > 0) {
        this.listOfStatus = this.removeElemetninArray(this.listOfStatus, $event.id)
      }
    }
    this.statusId = '';
    if (this.listOfStatus.length > 0) {
      this.statusId = $event.id;
    }
    this.filterModel.statusId = null;
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetWebinarLibrariesData();
  }

  onDeSelectAllStatus($event) {
    this.statusId = '';
    this.listOfStatus = [];
    this.filterModel.statusId = null;
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetWebinarLibrariesData();
  }

  onSelectFree($event) {
    this.listOfFree = this.removeElemetninArray(this.listOfFree, $event.id)
    this.listOfFree.push($event.id);
    this.freeId = ' ';
    if (this.listOfFree.length > 0) {
      this.freeId = $event.id;
      this.filterModel.freeId = this.freeId;
    }
    else {
      this.filterModel.freeId = null;
    }

    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetWebinarLibrariesData();
  }

  onDeSelectFree($event) {
    if (this.listOfFree != null) {
      if (this.listOfFree.length > 0) {
        this.listOfFree = this.removeElemetninArray(this.listOfFree, $event.id)
      }
    }
    this.freeId = '';
    if (this.listOfFree.length > 0) {
      this.freeId = $event.id;
    }
    this.filterModel.freeId = null;
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetWebinarLibrariesData();
  }

  onDeSelectAllFree($event) {
    this.freeId = '';
    this.listOfFree = [];
    this.filterModel.freeId = null;
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetWebinarLibrariesData();
  }



  removeElemetninArray(array, element) {
    return array.filter(e => e !== element);
  }

  onSelect($event) {
    if (this.listOfSectionID != null) {
      this.listOfSectionID = [];
      if (this.listOfSectionID.length > 0) {
        this.listOfSectionID = this.removeElemetninArray(this.listOfSectionID, $event.id)
        this.listOfSectionID.push($event.id);
      }
      else {
        this.listOfSectionID.push($event.id);
      }
    }
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.listOfSection = this.listOfSectionID.join(',');
    this.filterModel.section = this.listOfSection;
    this.GetWebinarLibrariesData();
  }

  onSelectAll($event) {
    for (const item of $event) {
      if (this.listOfSectionID != null) {
        if (this.listOfSectionID.length > 0) {
          this.listOfSectionID = this.removeElemetninArray(this.listOfSectionID, item.id)
          this.listOfSectionID.push(item.id);
        }
        else {
          this.listOfSectionID.push(item.id);
        }
      }
    }

    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.listOfSection = this.listOfSectionID.join(',');
    this.filterModel.section = this.listOfSection;
    this.GetWebinarLibrariesData();
  }

  onDeSelectAll($event) {
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.listOfSectionID = [];
    this.listOfSection = '';
    this.filterModel.section = this.listOfSection;
    this.GetWebinarLibrariesData();
  }

  onDeSelect($event) {
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    if (this.listOfSectionID != null) {
      if (this.listOfSectionID.length > 0) {
        this.listOfSectionID = this.removeElemetninArray(this.listOfSectionID, $event.id)
      }
    }
    this.listOfSection = this.listOfSectionID.join(',');
    this.filterModel.section = this.listOfSection;
    this.GetWebinarLibrariesData();
  }


  getAllSections() {
    this.webinarService.i360WebinarSectionListWithIds(this.tokenKey).subscribe(data => {
      if (data['status'] !== 'Failure') {
        for (let iCounter = 0; iCounter < data['sectionList'].length; iCounter++) {
          this.dropdownListSection.push(
            { 'id': data['sectionList'][iCounter].sectionId, 'itemName': data['sectionList'][iCounter].sectionName }
          );
        }
        if (this.listOfSectionID != null && this.listOfSectionID != undefined) {
          for (let iCounter = 0; iCounter < this.listOfSectionID.length; iCounter++) {
            if (this.listOfSectionID[iCounter] != '') {
              let obj = data["sectionList"].filter(m => m.productId == this.listOfSectionID[iCounter]);
              if (obj != null) {
                this.selectedItemsSection.push({ "id": obj[0].sectionId, "itemName": obj[0].sectionName });
              }
            }
          }
        }

      }
    });
  }

  drop(event: CdkDragDrop<string[]>): void {
    var CurrentShortOrder, PreviousShortOrder, currentcustomProductDetailsId, previouscustomProductDetailsId
    PreviousShortOrder = this.listOfWebinarLibraries[event.previousIndex]['sortOrder']
    previouscustomProductDetailsId = this.listOfWebinarLibraries[event.previousIndex]['webinarLibraryId']

    CurrentShortOrder = this.listOfWebinarLibraries[event.currentIndex]['sortOrder']
    currentcustomProductDetailsId = this.listOfWebinarLibraries[event.currentIndex]['webinarLibraryId']

    this.webinarService.i360WebinarUpdate(this.tokenKey, previouscustomProductDetailsId, currentcustomProductDetailsId).subscribe(
      data => {
        this.deletedId = 0;
        if (data != null) {
          this.webinarService.i360WebinarLibraryGet(this.tokenKey, this.filterModel).subscribe(
            data => {
              this.isloading = false;
              if (data != null) {
                this.listOfWebinarLibraries = data['webinarLibraryData'];
                if (this.listOfWebinarLibraries != null) {
                  if (this.listOfWebinarLibraries.length > 0) {
                    this.totalRecordCount = this.listOfWebinarLibraries[0].totalRecordCount;
                  }
                  else {
                    this.totalRecordCount = 0;
                  }
                }
                else {
                  this.totalRecordCount = 0;
                }
              }
            },
            error => {
              this.isloading = false;
              console.log(error);
            }
          );
        }
      },
      error => {
      }
    );

  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index; // Toggle the menu
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportWebinar() {
    this.isloading = true;
    this.filterModel.IsExport = true;
    this.listOfWebinarLibrariesExport = [];
    this.webinarService.i360WebinarLibraryGet(this.tokenKey, this.filterModel).subscribe(
      data => {
        if (data != null) {
          this.listOfWebinarLibrariesExport = data['webinarLibraryData'];
          if (this.listOfWebinarLibrariesExport != null) {
            if (this.listOfWebinarLibrariesExport.length > 0) {
              setTimeout(() => {
                this.DownloadWebinar();
                this.isloading = false;
              }, 2000);
            }
            else {
              this.isloading = false;
              this.toastr.error("No record found", "Error");
            }
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  DownloadWebinar() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportJSi360WebinarLibrary';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportJSi360WebinarLibrary.xls");
  }

}
